// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";

//阿里图标库
import "@/assets/icon/iconfont.css";

//加载样式
import "@/styles/common.scss";

import { getUSER, setUSER, getGUID, setGUID, $STORE, checkUSER } from "./auth";
import {
    geturl,
    geturltime,
    posturl,
    posturl2,
    postfile,
    posturlblob
} from "./ajax";
import { LoadParams } from "./main-params";
import { LoadRouter } from "./main-router";
import Clipboard from "vue-clipboard2";
Vue.use(Clipboard);
import { ZxImageView } from "zx-image-view";
import store from "./store"; // 引入store
import Vant from "vant";
import "vant/lib/index.css";
// import AFTableColumn from "af-table-column";

Vue.use(Vant);

//全局方法
import func from "./js/func"; // 引入
Vue.use(func); // 添加

import tipalert from "./views/chanpin/components/tipalert.vue";
Vue.component("tipalert", tipalert);
import yhqtag from "./views/youhuiquan/yhqtag.vue";
Vue.component("yhqtag", yhqtag);

Vue.config.productionTip = false;
Vue.use(ElementUI);
//Vue.use(AFTableColumn);

/* eslint-disable no-new */
Vue.prototype.$axios = axios.create({
    baseURL: "", // api 的 base_url
    timeout: 10000, // 请求超时时间
    withCredentials: true
});

const _config = {
    // 分页mouseover切换图片
    paginationable: true,
    // 显示关闭按钮
    showClose: true,
    // 显示上一张/下一张箭头
    showSwitchArrow: true,
    // 显示分页导航栏
    showPagination: true,
    // 显示工具栏
    showToolbar: true,
    // 缩放
    scalable: true,
    // 旋转
    rotatable: true,
    // 移动
    movable: true,
    // 键盘配置
    keyboard: {
        // scale: ['equal', 'minus']
    }
};

//设置本地GUID 长期存储
if (!getGUID()) {
    let _guid = guid();
    setGUID("@" + _guid);
}

import signalr from "./signalR";
Vue.use(signalr);

//不要在这里连接，会造成nginx连接太多
Vue.prototype.signalr.start().then(() => {
    console.log("连接");
});

const dateFormat = (fmt, date) => {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(
                ret[1],
                ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
            );
        }
    }
    return fmt;
};

Vue.prototype._LOG_LXW = (...str) => {
    //按照我的要求打印日志信息
    console.log(
        `%c>lxw ${dateFormat("YYYY-mm-dd HH:MM", new Date())}`,
        "font-size:20px;color:#fff;background-color:red"
    );
    str.map(o => {
        console.log(o);
    });
};

Vue.prototype.$IMG = new ZxImageView(_config);

Vue.prototype.$WEB = {
    getUSER,
    setUSER,
    getGUID,
    setGUID,
    $STORE
};
Vue.prototype.$AJAX = {
    geturl,
    geturltime,
    posturl,
    posturl2,
    postfile,
    posturlblob
};

//加载参数
LoadParams(Vue);

geturl("/api/site/getsite").then(x => {
    if (x.data.success) {
        //console.log("getsite", x.data.data);
        $STORE.state.Image = x.data.data.img;
        $STORE.state.Title = x.data.data.title;
        $STORE.state.Info = x.data.data.Info;
        $STORE.state.ZhuanBanOrZuShu = (
            x.data.data.ZhuanBanOrZuShu || "不足数|足数"
        ).split("|");
        $STORE.state.ICP = x.data.data.ICP; //AnQuanBeiAn
        $STORE.state.AnQuanBeiAn = x.data.data.AnQuanBeiAn;
        $STORE.state.Company = x.data.data.Company;
        $STORE.state.Site = x.data.data.Site;
        $STORE.state.SiteType = x.data.data.SiteType || "VIP";
        $STORE.state.OrderType = x.data.data.OrderType || "1";
        $STORE.state.DuoJiaGe = x.data.data.DuoJiaGe || "0";

        $STORE.state.HideHanShu = (x.data.data.HideHanShu || "0") == "1";
        $STORE.state.BJJinESFTuChu = (x.data.data.BJJinESFTuChu || "0") == "1";

        //设置citys
        $STORE.state.citys = x.data.data.citys || "";

        $STORE.state.ShowJiaGe = (x.data.data.ShowJiaGe || "1") == "1";
        $STORE.state.WWWHTTP = x.data.data.WWWHTTP;
        $STORE.state.WWWNAME = x.data.data.WWWNAME;

        //网站名称
        document.title = `自助报价`; //${$STORE.state.Title}

        let arr = Vue.prototype.$ThemeNames.filter(
            //防止维护的时候里面有空的字符串
            o => o.name == x.data.data.ThemeNameCN.replace(/\s+/g, "").split("|")[0]
        );

        let name = "default";
        if (arr.length > 0) name = arr[0].value;

        $STORE.commit("SET_THEME_NAME", name);
        document.body.className = name;
    }
});

//开启下单通道
geturl("/api/bjcanshu/getsBasequanjucanshu?bianhao=KaiQiXiaDanTongDao").then(
    x => {
        $STORE.state.KeXiaDan = x.data[0].v || "0";
        console.log($STORE.state.KeXiaDan, "xxxxxxxxx");
    }
);

// 判断浏览器类型
function getAppClient() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return "W01";
    } else if (ua.match(/QQ/i) == "qq") {
        return "Q01";
    } else if (ua.match(/AlipayClient/i) == "alipayclient") {
        return "A01";
    } else {
        return "U01";
    }
}

// 获取url参数
function getQueryVariable(variable) {
    var query = window.location.href.replace(/[\?#]/g, "&");
    // alert(window.location.href);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}

let browser = getAppClient() || "";
let source = getQueryVariable("fromty") || "";
sessionStorage.setItem("browser", browser);

// 如果来源是微信，本地openid有不存在，应该重新拉取用户信息
if (browser == "W01") {
    sessionStorage.setItem("laiyuan", "wx");
} else {
    if (source == "1") {
        // 设置为qq客户
        sessionStorage.setItem("laiyuan", "qqkehu");
    } else if (source == "2") {
        // 设置为qq客服
        sessionStorage.setItem("laiyuan", "qqkefu");
        // next('/qidianqqB')
    } else {
        // pc或者其他wap移动端
        sessionStorage.setItem("laiyuan", "pc");
        // next()
    }
}

//加载全局路由
LoadRouter(router);

// 设置状态
checkUSER();

// 获取guid
function guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

// HTTPrequest拦截
axios.interceptors.request.use(
    config => {
        //给页面添加一个编号
        var codeKey = "pageCode";
        if (!sessionStorage.getItem(codeKey)) {
            sessionStorage.setItem(codeKey, guid());
        }

        //前面已经判断了
        if (getGUID()) {
            config.headers["BJ-GUID"] = getGUID();
        }
        // else {
        //   // 单独请求服务器，获取最新的token信息，存储到本地
        //   let _guid = guid();
        //   setGUID(_guid);
        //   config.headers["BJ-GUID"] = _guid;
        // } 的
        //这里需要分两种情况，一种是base模式，另外一种是商务模式，需要通过参数判断

        //拦截请求
        if ($STORE.state.IsLogin && getUSER().token) {
            config.headers["Authorization"] = "bearer " + getUSER().token; // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// 添加响应拦截器
axios.interceptors.response.use(
    function(response) {
        // // 对响应数据做点什么
        // if (response.data.code == "401") {
        //     this.$message.warning("");
        // }

        return response;
    },
    err => {
        // 这里是返回状态码不为200时候的错误处理
        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    err.message = "请求错误";
                    break;

                case 401:
                    err.message = "未授权，请登录";
                    break;

                case 403:
                    err.message = "拒绝访问";
                    break;

                case 404:
                    err.message = `请求地址出错: ${err.response.config.url}`;
                    break;

                case 408:
                    err.message = "请求超时";
                    break;

                case 500:
                    err.message = "服务器内部错误";
                    break;

                case 501:
                    err.message = "服务未实现";
                    break;

                case 502:
                    err.message = "网关错误";
                    break;

                case 503:
                    err.message = "服务不可用";
                    break;

                case 504:
                    err.message = "网关超时";
                    break;

                case 505:
                    err.message = "HTTP版本不受支持";
                    break;

                default:
            }
        }

        return Promise.reject(err);
    }
);

var vm = new Vue({
    el: "#app",
    router,
    store,
    axios,
    components: { App },
    template: "<App/>"
});

// if(!Array.prototype.filter){
//   Array.prototype.filter = function(fun /*, thisp*/){
//     var len = this.length;
//     if (typeof fun != "function"){
//         throw new TypeError();
//     }
//     var res = new Array();
//     var thisp = arguments[1];
//     for (var i = 0; i < len; i++){
//         if (i in this){
//             var val = this[i]; // in case fun mutates this
//             if (fun.call(thisp, val, i, this)) {
//                 res.push(val);
//             }
//         }
//     }
//     return res;
//   };
// }

if (!Array.prototype.find) {
    Array.prototype.find = function(callback) {
        return callback && (this.filter(callback) || [])[0];
    };
}

if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, "findIndex", {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== "function") {
                throw new TypeError("predicate must be a function");
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        }
    });
}
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function forEach(callback, thisArg) {
        var T, k;

        if (this == null) {
            throw new TypeError("this is null or not defined");
        }
        var O = Object(this);
        var len = O.length >>> 0;
        if (typeof callback !== "function") {
            throw new TypeError(callback + " is not a function");
        }
        if (arguments.length > 1) {
            T = thisArg;
        }
        k = 0;

        while (k < len) {
            var kValue;
            if (k in O) {
                kValue = O[k];
                callback.call(T, kValue, k, O);
            }
            k++;
        }
    };
}


// WEBPACK FOOTER //
// ./src/main.js